module.exports = __webpack_public_path__ + "img/crew_adv_02.e60c6d31.png";